import React from "react"

import { useTranslation } from "react-i18next"

import { StatCard } from "components/stats/Card"

import { AnalyticsFreeSpinsStats } from "services/bonus/type"

import { getFreeSpinsStats } from "./analyticsHelpers"

interface Props {
  freeSpinsStats: AnalyticsFreeSpinsStats
  loading: boolean
}

export const FreeSpinsSummaryCard = ({ freeSpinsStats, loading }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  if (freeSpinsStats.totalAwarded === 0 && freeSpinsStats.totalUsed === 0) {
    return null
  }

  const stats = getFreeSpinsStats(freeSpinsStats)

  return (
    <div className="rounded-3xl border p-6 border-[rgba(0,0,0,0.05)] bg-white backdrop-blur-[9px] shadow-[0px_3px_6px_0px_rgba(192,192,192,0.6)] dark:border-[rgba(255,255,255,0.1)] dark:bg-[rgba(255,255,255,0.04)] dark:backdrop-blur-md dark:shadow-none">
      <h4 className="font-semibold mb-4 text-[rgba(6,7,21,1)] dark:text-white">{t("bonus2.analytics.freeSpinsSummary")}</h4>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <StatCard key={stat.title} title={t(stat.title)} value={stat.value} loading={loading} type={stat.isCurrency ? "currency" : undefined} />
        ))}
      </div>
    </div>
  )
}
